import { useContext } from "react"
import { Flex } from "@chakra-ui/react"

import {
  selectDepositActionDepositId,
  selectDepositActionToken,
  selectWalletAddress,
  selectWalletName,
  useDappSelector,
} from "#/redux-state"
import { FlowContext } from "#/shared/context"

import WithdrawalModalFormItem from "./WithdrawalModalFormItem"

export default function WithdrawalModalForm({
  onSuccess,
}: {
  onSuccess: () => void
}) {
  const token = useDappSelector(selectDepositActionToken)
  const depositId = useDappSelector(selectDepositActionDepositId)
  const walletName = useDappSelector(selectWalletName)
  const walletAddress = useDappSelector(selectWalletAddress)

  const { isBitcoinFlow } = useContext(FlowContext)

  if (!token || !depositId) return null

  if (token !== "BTC" || isBitcoinFlow) {
    return (
      <WithdrawalModalFormItem
        token={token}
        destinationLabel={walletName}
        destinationAddress={walletAddress}
        onSuccess={onSuccess}
      />
    )
  }

  return (
    <Flex flexDir="column" gap="16px" margin="0 28px">
      <WithdrawalModalFormItem
        isDetailed
        token="tBTC"
        isBitcoinDeposit
        destinationLabel={walletName}
        destinationAddress={walletAddress}
        onSuccess={onSuccess}
      />
      <WithdrawalModalFormItem
        isDetailed
        isEditable
        token="BTC"
        destinationAddress={null}
        destinationLabel={null}
        onSuccess={onSuccess}
      />
    </Flex>
  )
}
